import { theme } from '../../../styleguide'

export const getAuditInfo = {
  STOP: { title: 'Stop', theme: theme.audits.stop },
}
